(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mobileHeaderMediaQuery = window.matchMedia('(max-width: 989px)');
      this.mobileExploreDropdown = this.header.querySelector('.header-mobile-dropdown');
      this.noticeBanner = document.querySelector('[data-home-notice-banner]');
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.updateHeaderOffsets = this.updateHeaderOffsets.bind(this);
      this.handleMobileExploreToggle = this.handleMobileExploreToggle.bind(this);

      this.setHeaderHeight();

      this.headerHeightMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerHeightMediaQuery.addEventListener('change', this.setHeaderHeight);
      window.addEventListener('resize', this.setHeaderHeight);
      window.addEventListener('celestria:notice-banner-change', this.setHeaderHeight);
      window.addEventListener('scroll', this.updateHeaderOffsets, { passive: true });
      if (this.mobileExploreDropdown) {
        this.mobileExploreDropdown.addEventListener('toggle', this.handleMobileExploreToggle);
      }
      if (window.ResizeObserver) {
        this.headerOffsetObserver = new ResizeObserver(this.setHeaderHeight);
        this.headerOffsetObserver.observe(this.header);
        if (this.noticeBanner) {
          this.headerOffsetObserver.observe(this.noticeBanner);
        }
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateHeaderOffsets();
    }

    getVisibleNoticeOffset() {
      if (!this.mobileHeaderMediaQuery.matches || !this.noticeBanner || this.noticeBanner.classList.contains('is-hidden')) {
        return 0;
      }

      const noticeRect = this.noticeBanner.getBoundingClientRect();
      return Math.max(0, Math.round(noticeRect.bottom));
    }

    updateHeaderOffsets() {
      const headerHeight = this.header.offsetHeight;
      const noticeOffset = this.getVisibleNoticeOffset();
      const headerRect = this.header.getBoundingClientRect();
      const headerIsPinned =
        this.header.classList.contains('shopify-section-header-sticky') || this.shouldKeepHeaderVisibleForMobileExplore();
      const overlayTop = headerIsPinned ? noticeOffset + headerHeight : headerRect.bottom;

      document.documentElement.style.setProperty('--header-sticky-top', `${noticeOffset}px`);
      document.documentElement.style.setProperty('--header-overlay-top', `${Math.max(0, Math.round(overlayTop))}px`);
    }

    handleMobileExploreToggle() {
      if (this.mobileExploreDropdown.hasAttribute('open')) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.setHeaderHeight();
      requestAnimationFrame(this.updateHeaderOffsets);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('scroll', this.updateHeaderOffsets);
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('celestria:notice-banner-change', this.setHeaderHeight);
      if (this.headerHeightMediaQuery) {
        this.headerHeightMediaQuery.removeEventListener('change', this.setHeaderHeight);
      }
      if (this.mobileExploreDropdown) {
        this.mobileExploreDropdown.removeEventListener('toggle', this.handleMobileExploreToggle);
      }
      if (this.headerOffsetObserver) {
        this.headerOffsetObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateHeaderOffsets();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.shouldKeepHeaderVisibleForMobileExplore()) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
        this.updateHeaderOffsets();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    shouldKeepHeaderVisibleForMobileExplore() {
      return (
        this.mobileHeaderMediaQuery.matches &&
        this.mobileExploreDropdown &&
        this.mobileExploreDropdown.hasAttribute('open')
      );
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initDesktopMegaMenuHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const megaDetails = Array.from(document.querySelectorAll('header-menu details.mega-menu'));
    if (!megaDetails.length) return;

    megaDetails.forEach((details) => {
      if (details.dataset.hoverBound === 'true') return;
      details.dataset.hoverBound = 'true';

      const summary = details.querySelector('summary');
      let closeTimer;

      const closeMenu = () => {
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      };

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        megaDetails.forEach((otherDetails) => {
          if (otherDetails === details) return;
          otherDetails.removeAttribute('open');
          otherDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
        details.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(closeMenu, 140);
      });

      summary?.addEventListener('click', (event) => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        const topUrl = summary?.dataset?.topUrl;
        if (topUrl && topUrl !== '#') {
          event.preventDefault();
          window.location.href = topUrl;
          return;
        }
        event.preventDefault();
        if (details.hasAttribute('open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    });
  }

  function initMegaMenuTabs() {
    const tabGroups = Array.from(document.querySelectorAll('[data-mega-tabs]'));
    if (!tabGroups.length) return;

    tabGroups.forEach((tabGroup) => {
      if (tabGroup.dataset.tabsBound === 'true') return;
      tabGroup.dataset.tabsBound = 'true';

      const panelWrap = tabGroup.parentElement?.querySelector('[data-mega-tab-panels]');
      if (!panelWrap) return;

      const tabs = Array.from(tabGroup.querySelectorAll('[data-mega-tab-target]'));
      const panels = Array.from(panelWrap.querySelectorAll('[data-mega-tab-panel]'));
      if (!tabs.length || !panels.length) return;

      const activateTab = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.getAttribute('data-mega-tab-target') === targetId;
          tab.classList.toggle('mega-menu__tab-link--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-mega-tab-panel') === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          if (!isActive) return;

          const cardsTrack = panel.querySelector('[data-mega-cards-track]');
          if (cardsTrack) {
            cardsTrack.dispatchEvent(new CustomEvent('mega:panel-activated', { bubbles: true }));
          }
        });
      };

      const initialTab = tabs.find((tab) => tab.classList.contains('mega-menu__tab-link--active')) || tabs[0];
      if (initialTab) {
        activateTab(initialTab.getAttribute('data-mega-tab-target'));
      }

      tabs.forEach((tab) => {
        const targetId = tab.getAttribute('data-mega-tab-target');
        if (!targetId) return;

        const handleTabFocus = () => activateTab(targetId);
        tab.addEventListener('mouseenter', handleTabFocus);
        tab.addEventListener('focus', handleTabFocus);
        tab.addEventListener('click', handleTabFocus);
      });
    });
  }

  function initMegaCardsScroller() {
    const rows = Array.from(document.querySelectorAll('.mega-menu__cards-row'));
    if (!rows.length) return;

    rows.forEach((row) => {
      if (row.dataset.cardsScrollerBound === 'true') return;
      row.dataset.cardsScrollerBound = 'true';

      const track = row.querySelector('.mega-menu__cards');
      const nextButton = row.querySelector('[data-mega-cards-next]');
      if (!track || !nextButton) return;

      const refreshButtonState = () => {
        const parentPanel = row.closest('[data-mega-tab-panel]');
        if (parentPanel && parentPanel.hidden) {
          nextButton.hidden = true;
          return;
        }

        const hasOverflow = track.scrollWidth > track.clientWidth + 4;
        nextButton.hidden = !hasOverflow;
      };

      refreshButtonState();
      window.addEventListener('resize', refreshButtonState);
      row.addEventListener('mega:panel-activated', refreshButtonState);

      nextButton.addEventListener('click', () => {
        const firstCard = track.querySelector('.mega-menu__card');
        const step = firstCard ? firstCard.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        const nextPosition = Math.min(maxScrollLeft, track.scrollLeft + step * 2);
        const isAtEnd = maxScrollLeft - track.scrollLeft < 6;

        if (!isAtEnd) {
          track.scrollTo({ left: nextPosition, behavior: 'smooth' });
          return;
        }

        const fallbackUrl = nextButton.getAttribute('data-fallback-url');
        if (fallbackUrl) {
          window.location.href = fallbackUrl;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initDesktopMegaMenuHover);
  document.addEventListener('DOMContentLoaded', initMegaMenuTabs);
  document.addEventListener('DOMContentLoaded', initMegaCardsScroller);
  document.addEventListener('shopify:section:load', initDesktopMegaMenuHover);
  document.addEventListener('shopify:section:load', initMegaMenuTabs);
  document.addEventListener('shopify:section:load', initMegaCardsScroller);

  } catch(e) { console.error(e); }
})();
})();
